// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_text--solid"><path id="Union" d="M21.5 3C21.7761 3 22 3.22386 22 3.5V12H20V9.5H15V19H18V21H6V19H9V9.5H4V12H2V3.5C2 3.22386 2.22386 3 2.5 3H21.5Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_text--line"><path id="Union" d="M21.5 3C21.7761 3 22 3.22386 22 3.5V12H20V10H15.5V19H18V21H6V19H8.5V10H4V12H2V3.5C2 3.22386 2.22386 3 2.5 3H21.5ZM4 5V8H10.5V19H13.5V8H20V5H4Z" style="fill: currentColor"/></g></svg>`;

export const Text: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
